import script from "./PasswordChangeModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordChangeModal.vue?vue&type=script&setup=true&lang=js"

import "./PasswordChangeModal.vue?vue&type=style&index=0&id=f956399c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f956399c"]])

export default __exports__